'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function (AccountPage) {
    AccountPage["PROFILE"] = "profile";
    AccountPage["MARKETING_PREFS"] = "marketing-prefs";
    AccountPage["VERIFICATION"] = "verification";
    AccountPage["RESPONSIBLE_GAMING"] = "responsible-gaming";
    AccountPage["SOURCE_OF_WEALTH"] = "source-of-wealth";
    AccountPage["CLOSURE"] = "closure";
    AccountPage["CUSTOM_ITEM"] = "custom-item";
})(exports.AccountPage || (exports.AccountPage = {}));
